const deepFreeze = (obj) => {
  Object.freeze(obj);

  Object.keys(obj).forEach((key) => {
    const value = obj[key];

    // If the value is an object or array, recursively freeze it
    if (value && typeof value === 'object') {
      deepFreeze(value);
    }
  });

  return obj;
};

export default deepFreeze;
